import { axios } from '@/lib/axios';
import { TPlanInitialValues } from '../../containers/Settings/Plans/Plans.container';

import {
  IAPIDeletePlan,
  IAPIGetPlans,
  IAPIPatchPlan,
  IAPIPostPlan,
  IApiGet,
  TPlanTypePayment,
} from '../../types';

export const getPlans = (
  typePayment?: TPlanTypePayment
): Promise<IAPIGetPlans> => {
  const query = typePayment ? `?typePayment=${typePayment}` : "";

  return axios.get(
    `/payment-s/bo/api/v1/payments-plans-subscriptions${query}`
  );
};

export const createPlans = (
  datas: TPlanInitialValues
): Promise<IAPIPostPlan> => {
  return axios.post('/payment-s/bo/api/v1/payments-plans-subscriptions', {
    ...datas,
  });
};

export const editPlan = (
  id: string,
  datas: Partial<TPlanInitialValues>
): Promise<IApiGet<IAPIPatchPlan>> => {
  const { _id, typePayment, ...rest } = datas;
  return axios.patch(
    `/payment-s/bo/api/v1/payments-plans-subscriptions/${id}?typePayment=${typePayment}`,
    { ...rest }
  );
};

export const togglePlanActiveness = (
  id: string,
  typePayment: TPlanTypePayment
): Promise<IAPIDeletePlan> => {
  return axios.delete(
    `/payment-s/bo/api/v1/payments-plans-subscriptions/${id}/activate-or-deactivate?typePayment=${typePayment}`
  );
};

export type TSyncStripePlansError = {
  serviceId: string;
  planId?: string;
  planType?: string;
  planName?: string;
  error: string;
};

export type TSyncStripePlansResponse = {
  success: boolean;
  data: {
    syncedServices: number;
    syncedPlans: number;
    syncedPriceHistories: number;
    skippedServices: number;
    skippedPlans: number;
    errors: TSyncStripePlansError[];
  };
};

export const syncStripePlans = (): Promise<TSyncStripePlansResponse> => {
  return axios.post(
    "/payment-s/bo/api/v1/payments-plans-subscriptions/sync-stripe"
  );
};
